import React from 'react';
import Stylesheet from './notification.module.css';
import Classnames from 'classnames';

function Notification(props) {
    return (
        <div className={Classnames(Stylesheet.Container, {
            [Stylesheet['show']]: props.show,
            [Stylesheet['hide']]: !props.show
        })}>
            <h3>{props.icon}</h3>
            <div className={Stylesheet.Metadata}>
                <h4>{props.text}</h4>
                <h5>{props.description}</h5>
            </div>
        </div>
    )
}

export default Notification;